import './weaponCharge.css';

/** One reticle charge display shared by world play and races. */
export class WeaponChargeArc {
  readonly element=document.createElement('div');
  private readonly fill:SVGPathElement;
  private readonly label:HTMLElement;
  constructor(parent:HTMLElement=document.body){
    const el=this.element;el.className='weapon-charge';el.hidden=true;
    el.setAttribute('role','progressbar');el.setAttribute('aria-label','Weapon charge');
    el.setAttribute('aria-valuemin','0');el.setAttribute('aria-valuemax','100');
    el.innerHTML=`<svg viewBox="0 0 100 32" aria-hidden="true">
      <path class="weapon-charge-track" d="M 8 6 A 55 55 0 0 0 92 6"/>
      <path class="weapon-charge-fill" d="M 8 6 A 55 55 0 0 0 92 6" pathLength="1"/>
      </svg><span>HOLD FIRE</span>`;
    this.fill=el.querySelector('.weapon-charge-fill')!;this.label=el.querySelector('span')!;
    parent.append(el);
  }
  update(charge:number,held:boolean,visible:boolean):void {
    const value=Math.max(0,Math.min(1,charge));this.element.hidden=!visible;
    if(!visible)return;
    const phase=value>=1-1e-9?'ready':held?'charging':value>0?'decaying':'empty';
    this.element.dataset.phase=phase;
    this.element.setAttribute('aria-valuenow',String(Math.round(value*100)));
    this.fill.style.strokeDashoffset=String(1-value);
    this.fill.style.opacity=value>0?'1':'0';
    this.label.textContent=phase==='ready'?'READY':phase==='charging'?'CHARGING':phase==='decaying'?'DISCHARGING':'HOLD FIRE';
  }
}
